import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "house-slider-options"
}
const _hoisted_2 = {
  key: 1,
  class: "content-logo-slider"
}
const _hoisted_3 = { class: "content-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$props.isDesktop && $props.builder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderEstimatorHouseSelectorMobile"], {
            class: "builder-slider-buttons",
            items: $props.builder.houses,
            selectedItem: $props.selectedHouse ?? null,
            title: $setup.mobileTitle,
            contentTitle: $setup.mobileContentTitle,
            isLogoSwipe: true,
            isHouseSelectSlider: true,
            onOnSelectItem: $setup.onSelectHouse
          }, null, 8, ["items", "selectedItem", "title", "contentTitle"])
        ]))
      : _createCommentVNode("", true),
    ($props.isDesktop && $props.builder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "builder-logo",
              src: $props.builder.logo
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["BuilderEstimatorHouseSelectorDesktop"], {
              images: $props.builder.houses,
              selectedimage: $props.selectedHouse,
              isSelectDesign: true,
              onOnSelectImage: $setup.onSelectHouse
            }, null, 8, ["images", "selectedimage"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}